import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  SET_FOLLOWERS,
  SET_USER_PROFILE,
  SET_OTHER_USER_PROFILE,
  UserProfileAction,
  SET_REFRESH_KEY
} from './user-profile.action';

export interface UserProfileState {
  userProfile: [];
  otherUserProfile: [];
  following: [];
  refreshKeys: {};
}

const initialState: UserProfileState = {
  userProfile: [],
  otherUserProfile: [],
  following: [],
  refreshKeys: {}
};

export function UserProfileReducer(
  state = initialState,
  action: UserProfileAction
) {
  switch (action?.type) {
    case SET_USER_PROFILE:
      if (action.payload == null) {
        return {
          ...state,
          userProfile: initialState.userProfile
        };
      }
      return {
        ...state,
        userProfile: { ...action.payload }
      };
    case SET_OTHER_USER_PROFILE:
      return {
        ...state,
        otherUserProfile: action.payload
      };
    case SET_FOLLOWERS:
      return {
        ...state,
        following: action.payload
      };
    case SET_REFRESH_KEY:
      return {
        ...state,
        refreshKeys: action.payload
      };
    default:
      return state;
  }
}

export const getUserProfileState =
  createFeatureSelector<UserProfileState>('userProfile');
export const getUserProfileItems = createSelector(
  getUserProfileState,
  (state: UserProfileState) => state.userProfile
);

export const getRefreshState =
  createFeatureSelector<UserProfileState>('refreshKeys');
export const getRefreshStateItems = createSelector(
  getRefreshState,
  (state: UserProfileState) => state?.refreshKeys
);

export const getOthreUserProfileState =
  createFeatureSelector<UserProfileState>('otherUserProfile');
export const getOthreUserProfileItems = createSelector(
  getOthreUserProfileState,
  (state: UserProfileState) => state.otherUserProfile
);

export const getFollowerList =
  createFeatureSelector<UserProfileState>('following');
export const getFollowerListItems = createSelector(
  getUserProfileState,
  (state: UserProfileState) => state.following
);
